import { notifyError } from '@/projects/utils/notify'

const ADMIN_DASHBOARD_PATH = '/dashboard/admin'

function isEditableElement(element) {
  if (!element) return false
  const tagName = String(element.tagName || '').toLowerCase()
  if (element.isContentEditable) return true
  if (tagName === 'textarea' || tagName === 'select') return true
  if (tagName !== 'input') return false

  const type = String(element.getAttribute('type') || 'text').toLowerCase()
  return !['button', 'checkbox', 'file', 'hidden', 'radio', 'range', 'reset', 'submit'].includes(type)
}

export function isUserEditing() {
  if (typeof document === 'undefined') return false
  return isEditableElement(document.activeElement)
}

export function canAutoRefresh() {
  if (typeof document === 'undefined') return true
  if (document.visibilityState === 'hidden') return false
  return !isUserEditing()
}

export function recoverToAdminDashboard(vm, message, options = {}) {
  if (vm && vm.$store && message) {
    notifyError(vm.$store, message)
  }

  if (!(vm && vm.$router && vm.$route)) return

  const target = options.target || ADMIN_DASHBOARD_PATH
  if (vm.$route.path === target) return

  vm.$nextTick(() => {
    vm.$router.replace(target).catch(() => {})
  })
}
